// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2amNf","text":"style_text__HF_uP","count":"style_count__3yoge","teamName":"style_teamName__ITMcI"};